export const FORMAT_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'excel', label: 'Excel Sheets' },
  { value: 'word', label: 'Word Docs' },
  { value: 'pdf', label: 'PDF Documents' },
  { value: 'drawings', label: 'Drawings' },
];

export const DOCUMENT_SECTIONS = [
  { id: 'excel', title: 'Excel Spreadsheets', colorClass: 'bg-emerald-50 text-emerald-600', format: 'excel' },
  { id: 'word', title: 'Word Documents', colorClass: 'bg-blue-50 text-blue-600', format: 'word' },
  { id: 'pdf', title: 'PDF Documents', colorClass: 'bg-amber-50 text-amber-700', format: 'pdf' },
  { id: 'drawings', title: 'Drawings', colorClass: 'bg-purple-50 text-purple-600', format: 'drawings' },
  { id: 'other', title: 'Other Files', colorClass: 'bg-slate-50 text-slate-600', format: 'other' },
];
